import React from 'react';
import { Heart } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';
import { useTheme } from '../../../contexts/ThemeContext';

const TechnologyLikeButton = ({ likes = 0, likedBy = [], onToggle, loading = false, size = 'sm' }) => {
  const { currentUser } = useAuth();
  const { darkMode } = useTheme();
  const isLiked = currentUser && likedBy.includes(currentUser.uid);
  const iconSize = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!currentUser) {
      alert('Please log in to like resources.');
      return;
    }
    onToggle?.();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium transition-colors ${
        isLiked
          ? 'bg-red-50 text-red-600 dark:bg-red-900/20 dark:text-red-400'
          : darkMode
            ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
      } ${loading ? 'opacity-60 cursor-wait' : ''}`}
      aria-label={isLiked ? 'Unlike' : 'Like'}
    >
      <Heart className={`${iconSize} ${isLiked ? 'fill-current' : ''}`} />
      <span>{likes ?? 0}</span>
    </button>
  );
};

export default TechnologyLikeButton;
